import type { ButtonSize } from '@mntn/ui-components'
import { cn, Icon } from '@mntn/ui-components'
import { forwardRef } from 'react'
import { Button } from './button'

interface AddBudgetButtonProps {
  isLoading?: boolean
  isDisabled?: boolean
  size?: ButtonSize
  className?: string
  label?: string
}

export const AddBudgetButton = forwardRef<HTMLButtonElement, AddBudgetButtonProps>(
  ({ isLoading = false, isDisabled = false, size = 'tiny', className, label = 'Add', ...props }, ref) => (
    <Button
      ref={ref}
      size={size}
      variant="screen"
      disabled={isDisabled}
      className={cn('gap-2 shadow-lg disabled:opacity-40 data-[state=open]:bg-sub-screen-bg-inverse/80', className)}
      {...props}
    >
      {label}
      <Icon
        name={isLoading ? 'LoaderCircle' : 'DollarSign'}
        className={cn('size-[14px] text-secondary-accent-inverse', isLoading && 'animate-spin')}
      />
    </Button>
  ),
)

AddBudgetButton.displayName = 'AddBudgetButton'
